export default __webpack_public_path__ + "static/green flower-f821e5e4b5da3fe5235e52c66304fd33.png";